import axios from 'axios';


export default{
    getUsers: async function()
    {
        const url='Users/GetUsers';
        const token=localStorage.getItem('accessToken');
        const response=await axios.get(url,{crossdomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response;
    },
    getUsersByBuilding: async function(buildingCode)
    {
        const url=`Users/${buildingCode}/GetUsersByBuilding`;
        const token=localStorage.getItem('accessToken');
        const response=await axios.get(url,{crossdomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response;
    },
    GetUserNotAsignedByBuilding: async function(buildingCode){
        const url=`Users/${encodeURIComponent(buildingCode)}/GetUserNotAsignedByBulding`;
        const token=localStorage.getItem('accessToken');
        const response= await axios.get(url,{crossdomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    getPrimaryContactByBuilding: async function(buildingCode){
        const url= `Users/${buildingCode}/GetPrimaryContactByBuilding`;
        const token=localStorage.getItem('accessToken');
        const response=await axios.get(url,{crossdomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    GetNonAssignedPrimaryContactBuilding: async function(buildingCode)
    {
        const url=`Users/${buildingCode}/GetNonAssignedPrimaryContactBuilding`;
        const token=localStorage.getItem('accessToken');
        const response=await axios.get(url, {crossdomain: true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    updateBuildingUser: async function(buildingUser)
    {
        const url='Users/UpdateBuildingUser';
        const token=localStorage.getItem('accessToken');
        const response=await axios.put(url, buildingUser, {crossdomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response;
    },
    testEmailSendFrom: async function(email){
        const url='Email/SendEmail';
        const token=localStorage.getItem('accessToken');
        const response=await axios.post(url, email,{crossdomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response;
    },
    replaceUser: async function(replacementUser){
        const url='Users/ReplaceUser';
        const token=localStorage.getItem('accessToken');
        const response=await axios.put(url,replacementUser,{crossdomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response;
    },
    MailingContactReplacement: async function(user){
        const token=localStorage.getItem('accessToken');
        const response=await axios.put('Users/MailingContactReplacement',user,{crossdomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    MailingContactReplacementByUserFull: async function(buildingCode, user)
    {
        const token=localStorage.getItem('accessToken');
        const url=`Users/${encodeURIComponent(buildingCode)}/MailingContactReplacementByBuildingFull`;
        const response=await axios.put(url,user, {crossdomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    MailingContactReplacementByUser: async function(buildingCode, user)
    {
        const token=localStorage.getItem('accessToken');
        const url=`Users/${encodeURIComponent(buildingCode)}/MailingContactReplacementByBuilding`;
        const response=await axios.put(url,user, {crossdomain:true,headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    addNewUser: async function(user){
        const url='Users/AddNewUser';
        const token=localStorage.getItem('accessToken');
        const response=await axios.post(url, user,{crossdomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response;
    },
    AddUserBuilding: async function(buildingUser)
    {
        const url='Users/AddUserBuilding';
        const token=localStorage.getItem('accessToken');
        const response=await axios.post(url,buildingUser,{crossdomain: true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    }

}